import { Outlet, Navigate } from "react-router-dom";
import { useState, useEffect } from "react";

const PrivateRoutes = () => {
    const [isAdmin, setIsAdimin] = useState(true);
//   useEffect(() => {
    
//     const check = JSON.parse(sessionStorage.getItem("type_user"));
//     console.log(typeof check);
//     if (check == "reg") {
//       setIsAdimin(true);
//       console.log(isAdmin);
//     }
//   }, []);

  return isAdmin ? <Outlet /> : <Navigate to="/welcome" />;
};
export default PrivateRoutes;
